module.exports = __webpack_public_path__ + "img/Dannyna_wystawie_tn.1100e3c0.jpg";